import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {PASSWORD_ALLOWED_CHAR_CLASS, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, PASSWORD_SPECIAL_CHAR_CLASS} from '../domain/constants';

const ALLOWED_CHARS = new RegExp(`^${PASSWORD_ALLOWED_CHAR_CLASS}+$`);
const HAS_LOWERCASE = /[a-z]/;
const HAS_UPPERCASE = /[A-Z]/;
const HAS_DIGIT = /[0-9]/;
const HAS_SPECIAL = new RegExp(PASSWORD_SPECIAL_CHAR_CLASS);

export function passwordRequirementChecks(value: string): PasswordRequirementChecks {
    return {
        length: value.length >= PASSWORD_MIN_LENGTH && value.length <= PASSWORD_MAX_LENGTH,
        charset: ALLOWED_CHARS.test(value),
        case: HAS_LOWERCASE.test(value) && HAS_UPPERCASE.test(value),
        digit: HAS_DIGIT.test(value),
        special: HAS_SPECIAL.test(value),
    };
}

export function meetsPasswordRequirements(value: string): boolean {
    const checks = passwordRequirementChecks(value);
    return checks.length && checks.charset && checks.case && checks.digit && checks.special;
}

export function passwordRequirementsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        return meetsPasswordRequirements(value) ? null : {passwordRequirements: true};
    };
}

export interface PasswordRequirementChecks {
    length: boolean;
    charset: boolean;
    case: boolean;
    digit: boolean;
    special: boolean;
}
